export const formatInvoiceServiceLine = (invoiceServiceLinesFormData, invoiceLines) => {
    return invoiceServiceLinesFormData.map(invoiceService => {
        const {partnerName, partnerAddress, partnerType, requestedAmount, ...restInvoiceService} = invoiceService;

        let isApprovedAmountChanged = false;

        if (invoiceLines.length === 1 && !Number(invoiceService.approvedAmount)) return;

        invoiceLines.forEach(line => {
            if (line.lineNo === invoiceService.lineNo
                && (Number(restInvoiceService?.approvedAmount?.replace(',', '.')).toFixed(2) !== Number(line.approvedAmount).toFixed(2)
                    || (line.approvedAmount === null && Number(restInvoiceService?.approvedAmount) === 0))) {
                isApprovedAmountChanged = true;
            }
        });

        if (!isApprovedAmountChanged) return;

        return {
            ...restInvoiceService,
            amount: requestedAmount,
            approvedAmount: Math.round(Number(restInvoiceService.approvedAmount?.replace(',', '.')) * 100) / 100,
            ...(partnerName && {partnerName}),
            ...(partnerAddress && {partnerAddress}),
            ...(partnerType && {partnerType}),
        };
    }).filter(value => !!value);
};
